export default __webpack_public_path__ + "static/6812-da095552e25a712fb0881445a367c36e.jpg";